 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Has been modified. Do not replace. - Michael Large
 *
 * Creates and uses srcSet attributes for background images.
 * @author Jesse Kernaghan <https://github.com/jessekernaghan/bgsrcset.js>
 */
(function () {
  'use strict';

  var bgsrcset = function bgsrcset() {

    this.called = false;
    this.callonce = true;
    this.compat();
  };

  bgsrcset.prototype.init = function (target, callback) {
    //retina bool
    this.retina = window.devicePixelRatio > 1;

    //storage for our elements
    this.elements = [];

    //global onload callback for imagery
    this.callback = typeof callback === 'function' ? callback : function () {};

    //window width, for responsive handling
    this.curwidth = this.getWidth();

    //get our input and turn it into an element list of some sort
    //   var elems = this.gather(target);
    var elems = document.querySelectorAll('[data-bg-srcset]');

    //parse the element input
    for (var i = 0, l = elems.length; i < l; i++) {
      this.parse(elems[i]);
    }

    this.set();
    this.resize();
  };

  /* -----------* /
     Fix compatibility issues*
     *only down to IE8
  / *----------- */

  bgsrcset.prototype.compat = function () {
    var d = document;
    /* check for getElementsByClassName */
    if (typeof d.getElementsByClassName !== 'function') {
      d.getElementsByClassName = function (str) {
        return d.querySelectorAll('.' + str);
      };
    }

    /* check for .trim() */
    if (!String.prototype.trim) {
      String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }

    /*------------------------* /
      Check for Event Listener
    / *------*/
    if (!d.addEventListener) {
      this.addEvent = function (elem, evName, fn) {
        elem.attachEvent('on' + evName, function (e) {
          fn(e || window.event);
        });
      };
    }
  };

  /* -----------* /
     Gather elements
  / *----------- */

  bgsrcset.prototype.gather = function (target) {
    var autotypes = ['HTMLCollection', 'NodeList'];
    var e = target;
    var type = e.nodeType ? 'Object' : Object.prototype.toString.call(e).replace(/^\[object |\]$/g, '');

    var func = 'parse' + type;

    if (autotypes.indexOf(type) > -1) {
      return e;
    }

    if (this[func]) {
      return this[func](e);
    }

    return [];
  };

  bgsrcset.prototype.parseObject = function (target) {
    return target.nodeType ? [target] : [];
  };

  bgsrcset.prototype.parseArray = function (target) {
    return target;
  };

  bgsrcset.prototype.parseString = function (target) {

    var d = document;
    var e = target.trim();
    var sel = e[0];
    var elems = [];

    switch (true) {
      /* class */
      case sel === '.':
        elems = d.getElementsByClassName(e.substring(1));
        break;
      /* id */
      case sel === '#':
        elems.push(d.getElementById(e.substring(1)));
        break;
      /* tag */
      case /^[a-zA-Z]+$/.test(e):
        elems = d.getElementsByTagName(e);
        break;
      /* unknown */
      default:
        elems = [];
    }

    return elems;
  };

  /* -----------* /
     Parse datasrc
  / *----------- */
  bgsrcset.prototype.parse = function (obj) {
    //our data to parase
    var bgss = obj.dataset.bgSrcset;
    /* exit if no attribute */
    if (attr === null) {
      console.log("NO BG SRCSET");return false;
    }

    /* create new element object */
    this.elements.push({});

    /* split up sets */
    var set = bgss.split(',');
    var attr = '';
    var curelem = this.elements[this.elements.length - 1];

    curelem.node = obj;
    curelem.srcset = [];

    /* loop through sets to define breakpoints */
    for (var i = 0, l = set.length; i < l; i++) {
      curelem.srcset.push({});
      attr = set[i].trim();
      var attrs = attr.split(' ');
      var a;
      var e;
      var t;
      /* since we can't know the order of the values, starting another loop */
      for (var attrc = 0, attrl = attrs.length; attrc < attrl; attrc++) {
        a = attrs[attrc];
        e = curelem.srcset[i]; //current attribute
        t = a.length - 1;
        switch (true) {
          case a.trim() === "":
            //in case of extra white spaces
            continue;
          case a[t] !== 'w' && a[a.length - 1] !== 'x':
            e.src = a;
            break;
          case a[t] === 'w':
            e.width = parseInt(a.slice(0, -1));
            break;
          case a[t] === 'x':
            e.retina = parseInt(a.slice(0, -1)) > 1;
            break;
        }
        if (!e.width) {
          e.width = Number.POSITIVE_INFINITY;
        } //set to the top
        if (!e.retina) {
          e.retina = false;
        }
      }
    }
  };

  /* -----------* /
     Set image
  / *----------- */
  bgsrcset.prototype.set = function () {
    for (var i = 0, l = this.elements.length; i < l; i++) {
      this.setSingle(i);
    }
  };

  bgsrcset.prototype.setSingle = function (id) {
    var width = 0,
        elem = this.elements[id],
        comparray = [],
        best = 0,
        _this = this;

    //      width = this.getWidth(); //elem.node.offsetWidth;
    // 2017-10-06, use the container width and not window width. Experiemental.
    width = elem.node.offsetWidth;

    elem.srcset = elem.srcset.sort(dynamicSort("width"));

    for (var i = 0, l = elem.srcset.length; i < l; i++) {
      if (elem.srcset[i].width < width) {
        continue;
      }
      comparray.push(elem.srcset[i]);
    }
    if (comparray.length === 0) {
      comparray.push(elem.srcset[elem.srcset.length - 1]);
    }

    best = comparray[0];

    if (comparray.length > 1 && comparray[0].width === comparray[1].width) {
      best = comparray[0].retina !== this.retina ? comparray[1] : comparray[0];
    }

    if (best.src !== undefined && best.src !== 'null') {
      var img = new Image();
      var done = false;

      img.onload = img.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
          done = true;

          elem.node.style.backgroundImage = "url('" + best.src + "')";

          /* only fire the callback on initial load, not resize events */
          if (!_this.called) {

            _this.callback(elem);
            _this.called = _this.callonce;
          }
        }
      };

      img.src = best.src;
    } else {
      elem.node.style.backgroundImage = "";
    }
  };

  /* -----------* /
     Handle Resize
  / *----------- */
  bgsrcset.prototype.resize = function () {
    var _this = this,
        resizeTimer = setTimeout(function () {}, 0);

    this.addEvent(window, 'resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = _this.getWidth();
        if (w !== _this.curwidth) {
          _this.curwidth = w;
          _this.set();
        }
      }, 250);
    });
  };

  bgsrcset.prototype.addEvent = function (elem, evName, fn) {
    elem.addEventListener(evName, fn, false);
  };

  bgsrcset.prototype.getWidth = function () {
    var w, d, e, g;
    w = window;
    d = document;
    e = d.documentElement;
    g = d.getElementsByTagName('body')[0];

    return w.innerWidth || e.clientWidth || g.clientWidth;
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;a;
    };
  }

  window.bgsrcset = bgsrcset;
})();

// Creates SourceSet for background images.
var bgss = new bgsrcset();
bgss.init('.bgimg'); // Re-called in debug.js
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
* @file cookie.js
* Generic cookie handling functions.
* @author Hal Burgiss 2009-03-22
*/
function setCookie(name, value, days) {
     if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = "; expires=" + date.toGMTString();
     } else var expires = "";
     document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
     var nameEQ = name + "=";
     var ca = document.cookie.split(';');
     for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
               c = c.substring(1, c.length);
          }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
     }
     return null;
}
function eraseCookie(name) {
     setCookie(name, "", -1);
}
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Debounce function for rate limiting a function.
 *
 * It prevents a function from being fired too frequently. This is useful
 * for resource intensive processes like resize event handlers and tap/click
 * handlers.
 *
 *
 * @see: https://davidwalsh.name/javascript-debounce-function
 *
 * @param function func - the callback function
 * @param int wait - the time to wait in milliseconds
 * @param bool immediate - call the function immediately
 *
 * @return function - the modified function that will only run once within a wait period.
 */
function debounce(func, wait, immediate) {
    var timeout;
    if (!wait) {
        console.warn("Debounce was called without a 'wait' argument. This renders debounce almost completely ineffective.");
    }
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

/**
 * Debounce scroll event for rate limiting scroll events.
 *
 * Putting events on the scroll handler should usually be discouraged
 * as they can be fired very frequently and this can cause the browser
 * to lag.
 *
 * Instead, use this event: debounceScroll
 *
 * This allows us to have only one scoll event handler that triggers
 * the debounceScoll event (on the window) 50ms (or whatever the
 * delay_time is set) after a scroll event starts and then stops.
 *
 *
 * @see: http://ejohn.org/blog/learning-from-twitter/#postcomment
 * (particularly read the comments for this variant)
 *
 * @usage:
 *
 *  	window.addEventListener( 'debounceScroll', function() {
 *  		console.log( 'scrolled....');
 *  	}, false );
 */
var debounceScroll = create_event('debounceScroll');

window.addEventListener('load', function () {
    var delay_time = 50;
    var delay_start = 0;
    var last_scroll_pos = 0;

    function scroll() {
        // If we are already scrolling, reset the delay
        if (delay_start) {
            clearTimeout(delay_start);
        }

        // Are we scrolling down?
        var scrollDown = window.pageYOffset > last_scroll_pos;
        last_scroll_pos = window.pageYOffset; // Save for next time

        delay_start = setTimeout(function (event) {
            debounceScroll.scrollDown = scrollDown;
            window.dispatchEvent(debounceScroll);
        }, delay_time);
    }

    // For momentum-scrolling touch devices that only trigger a scroll event on scroll-end
    if ('touchmove' in document.documentElement) {
        window.addEventListener('touchmove', function () {
            scroll();
        });
    } else {
        // Non-touch devices
        window.addEventListener('scroll', function () {
            scroll();
        });
    }
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Modal object for creating modals.
 *
 * @usage:
 *
 * 	var myModal = new Modal( element, { 'open' : true, 'onOpen' : myFunction );
 *
 * 	Assumes html like:
 *
 *  	<div class="modal">
 *  		<!-- a 'modal' can have more than one 'modal__box'es. -->
 *  		<div class="modal__box" >
 *  			<a href="#close" title="Close" class="modal__close_btn">Close</a>
 *  			<h2>A header</h2>
 *  			<p>A bunch of random text here. A bunch of random text here. And some more!</p>
 *  			<a href="#close" title="Close" class="modal__button" data-action="close">Continue</a>
 *  		</div>
 *  	</div>
 *
 *
 * @param element - DOM element that is the container for the modal
 * @param object - object containing optional attributes using this format:
 * 		{
 *
 * 			// When set, opens modal at creation.
 * 			'open' : false,
 *
 * 			// When set, clicking outside a modal box closes the modal.
 * 			'close_on_click_away' : true,
 *
 * 			// When set, displays only once (based on a cookie).
 * 			// TODO: not yet implemented
 * 			'show_once' : false,
 *
 * 			// Function to run when opening modal
 * 			'onOpen'  : function() {},
 *
 * 			// Function to run when closing modal
 * 			'onClose' : function() {},
 *
 * 		}
 *
 * @author HGB3 12/12/2016
 */
function Modal(element, atts) {

	// First try to use atts passed as an arg, if none were passed, try global modalAttributes.
	// Otherwise, just use an empty object
	if (!atts) {
		if (typeof modalAttributes !== 'undefined') {
			atts = modalAttributes;
		} else {
			atts = {};
		}
	}

	var attributes = { // If available, use passed attributes, otherwise use defaults
		'open': atts.open !== undefined ? atts.open : false,
		'close_on_click_away': atts.close_on_click_away !== undefined ? atts.close_on_click_away : true,
		'show_once': atts.show_once !== undefined ? atts.show_once : false,
		'onOpen': atts.onOpen || function () {},
		'onClose': atts.onClose || function () {}
	};

	if (!element) {
		// Sanity check
		console.warn('Cannot create Modal without modal element.');
		return;
	}

	this.element = element;

	this.name = this.element.dataset.name;

	// Store a reference to the modal object on the element.
	this.element.modal = this;

	// Event Handlers

	var modal = this; // Closure on which to attach 'this'
	var close = function close() {
		modal.close();
	};

	var closeButtons = this.element.querySelectorAll('.modal__close_button');
	for (var i = 0; i < closeButtons.length; i++) {
		closeButtons[i].addEventListener('click', close);
	}

	// For all modal buttons, set up event handler for action data attribute.
	var bindModalButton = function bindModalButton(button) {
		var action = button.dataset.action;
		if (action && typeof modal[action] === 'function') {
			button.addEventListener('click', function (event) {
				modal[action]();
				event.preventDefault();
			});
		}
	};

	var modalButtons = this.element.querySelectorAll('.modal__button');
	for (var j = 0; j < modalButtons.length; j++) {
		bindModalButton(modalButtons[j]);
	}

	if (attributes.close_on_click_away) {
		// Close when clicking the element (the area around the modal)...
		this.element.addEventListener('click', close);

		// ...but don't allow click events to bubble up past modal boxes.
		// They should handle their own events.
		var modalBoxes = this.element.querySelectorAll('.modal__box');
		for (var k = 0; k < modalBoxes.length; k++) {
			modalBoxes[k].addEventListener('click', function (event) {
				event.stopPropagation();
			});
		}
	}

	// onOpen event handler
	this.onOpen = attributes.onOpen;

	// onClose event handler
	this.onClose = attributes.onClose;

	if (attributes.open) {
		this.open();
	}
}

/**
 * Hides the modal
 *
 * Adds hide class and removes show class on modal container element.
 * Animation should be done in stylesheets.
 */
Modal.prototype.hide = function () {
	this.element.classList.add('hide');
	this.element.classList.remove('show');
};

/**
 * Shows the modal
 *
 * Adds show class and removes hide class on modal container element.
 * Animation should be done in stylesheets.
 */
Modal.prototype.show = function () {
	this.element.classList.add('show');
	this.element.classList.remove('hide');
};

/**
 * Opens the modal
 * Also runs onOpen event handler.
 */
Modal.prototype.open = function () {
	this.show();
	this.onOpen();
};

/**
 * Closes the modal
 * Also runs onClose event handler.
 */
Modal.prototype.close = function () {
	this.hide();
	this.onClose();
};

/**
 * Automatically creates a modal object for every element that has a class of
 * 'modal'.
 */
window.addEventListener('load', function () {

	// Store them in this array
	document.modals = [];

	var modalElements = document.querySelectorAll('.modal');
	for (var i = 0; i < modalElements.length; i++) {
		var modalElement = modalElements[i];
		var name = modalElement.dataset.name;
		var attributes = modalElement.dataset.attributes;
		var atts;

		if (attributes && typeof dbs !== 'undefined' && dbs.modals) {
			atts = dbs.modals[attributes];
		}

		if (name) {
			document.modals[name] = new Modal(modalElement, atts);
		} else {
			document.modals.push(new Modal(modalElement, atts));
		}
	}
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Slate Mobile Navigation Menu
 *
 */
(function () {

	'use strict';

	/**
  * 'is_mobile' variable to determine if this is a mobile size.
  */

	var set_is_mobile,
	    is_mobile = false;

	window.addEventListener('load', function () {
		var menuToggle = document.getElementById('menu-toggle');

		(set_is_mobile = function set_is_mobile() {
			if (window.getComputedStyle(menuToggle).display === "none") {
				is_mobile = false;
			} else {
				is_mobile = true;
			}
		})();

		/**
   * Toggle menu open/closed when clicking menu toggle
   */
		menuToggle.addEventListener('click', function () {
			this.classList.toggle('open');
			document.getElementById('menu').classList.toggle('open');
			document.querySelector('body').classList.toggle('opened-menu');

			if (this.classList.contains('open')) {
				this.setAttribute('aria-expanded', true);
			} else {
				this.setAttribute('aria-expanded', false);
			}
		});
	});

	var subToggles = document.querySelectorAll('.submenu-toggle');

	for (var i = 0; subToggles.length > i; i++) {
		var focus_out_timer = null;
		var toggle_button = subToggles[i];

		toggle_button.addEventListener('click', function () {
			this.classList.toggle('open');
			this.parentNode.classList.toggle('open');

			if (this.classList.contains('open')) {
				this.setAttribute('aria-expanded', true);
			} else {
				this.setAttribute('aria-expanded', false);
			}
		});
	}
})();
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

/*
A little info for this js file:
	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
	As mentioned below, most code added to this file should be included within the "on load" function.
	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
	including any relavant details regarding what the code overrides, etc.
*/

(function () {
	'use strict';

	// rerun lazyload on screen size updates

	window.addEventListener('resize', function () {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener('load', function () {
		/* Search Form functionality
   * The click functionality involves three different actions,
   * depending on conditions the various clicks provide.
   * 
   * NOTE: This script assumes there is one search form on the page.
   */
		var searchOpen = document.querySelectorAll('.search-form__button--open');
		var searchClose = document.querySelectorAll('.search-form__button--close');

		if (searchOpen) {
			for (var i = 0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener('click', function () {
					this.parentElement.classList.add('search-form--active');
					this.parentElement.querySelector('.site_search__field').focus();

					// Hide the search bar after click out of it
					document.getElementById('content').addEventListener('click', function () {
						if (this.parentElement.classList.contains('search-form--active')) {
							this.parentElement.classList.remove('search-form--active');
						}
					});
				});
			}

			for (var i = 0; searchClose.length > i; i++) {
				searchClose[i].addEventListener('click', function () {
					this.parentElement.classList.remove('search-form--active');
				});
			}
		}

		/**
   * Animated Form Labels
   * 
   * CSS class must be added in GForms admin on each field that will need to animate.
   */
		var animateForm = document.querySelectorAll('.animate-labels');

		if (animateForm) {
			var inputs = document.querySelectorAll('.animate-labels input');

			for (var i = 0; inputs.length > i; i++) {
				var input = inputs[i];

				input.addEventListener('focus', function () {
					if (this.parentElement.classList.contains('ginput_container')) {
						this.parentElement.parentElement.classList.add('active');
					} else {
						this.parentElement.classList.add('active');
					}
				});

				input.addEventListener('blur', function () {
					var $this = this;

					setTimeout(function () {
						if ($this.value == '') {
							$this.parentElement.parentElement.classList.remove('active');
							$this.parentElement.classList.remove('active');
						}
					}, 100);
				});
			}
		}

		/**
   * Linkclicker
   * 
   * A class placed on a wrapping element with a link inside to make the wrapper clickable.
   */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for (var i = 0; linkclickers.length > i; i++) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function (e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');

				if (link.getAttribute('target', "_blank")) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}

		/**
   * Force external links/PDFs to open in a new tab.
   * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
   * 2019-07-11 - TA
   */
		function link_is_external(link_element) {
			return link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1;
		}

		var anchorElements = document.getElementsByTagName('a');
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = anchorElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var anchorElement = _step.value;


				if (link_is_external(anchorElement)) {
					anchorElement.setAttribute('target', '_blank');
					anchorElement.setAttribute('rel', 'noopener');

					// Add assistive text to alert of external links
					var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
					var assistiveTextContainer = document.createElement('span');
					assistiveTextContainer.innerHTML = assistiveText;
					anchorElement.appendChild(assistiveTextContainer.firstChild);
				}
			}

			/**
    * Detects if element is in viewport
    * 
    * @usage
    * var el = document.querySelector('.home-panes__line');
    *
    * window.addEventListener('scroll', function(event) {
    * 		if (isInViewport(el)) {
    *			el.classList.add("in-view");
    *		}
    * }, false);
    */
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		function isInViewport(elem) {
			var distance = elem.getBoundingClientRect();
			return distance.top >= 0 && distance.left >= 0 && distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) && distance.right <= (window.innerWidth || document.documentElement.clientWidth);
		};
	}); // End of load function


	// Include ready events here
	window.addEventListener('DOMContentLoaded', function () {});

	/**
  * Js for detecting a modals id and opening that modal
  */
	var modalToggles = document.querySelectorAll('.modal__open');
	for (var i = 0; modalToggles.length > i; i++) {
		modalToggles[i].addEventListener('click', function (e) {
			var relativeModal = this.getAttribute('href');
			e.preventDefault();
			document.getElementById(relativeModal).classList.remove('hide');
		});
	}

	/**
  * Cookie Popup scripts
  */
	var popUp = document.getElementById('cookie-popup');
	var popUpMain = document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie("accepts-cookie", "accepts-cookie-set", 365);
	}

	document.getElementById('accept-button').addEventListener('click', function () {
		accept();
	});

	var cookie = readCookie('accepts-cookie');
	// If user already has accepted cookies, don't show popup
	if (cookie == 'accepts-cookie-set') {
		popUp.style.display = "none";
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();